<script lang="ts" setup>
import { Prop } from 'vue'

import CopyClipboardIcon from '@/components/Icons/CopyClipboardIcon.vue'

import { Code } from '~/api/modules/sales/types'

const emit = defineEmits(['copyPromocode'])
const props = defineProps({
  code: {
    type: Object,
    required: true,
  } as Prop<Code>,
})

const isActiveCode = props.code?.active || false
const promocodeText = props.code?.active
  ? 'Кликните на промокод, чтобы скопировать:'
  : 'Промокод неактивен'

const copyPromocode = () => emit('copyPromocode')
</script>

<template>
  <div class="promocode">
    <span v-if="isActiveCode" class="promocode__title">Промокод:</span>

    <div class="promocode__section">
      <div class="promocode__section-text" :class="{ unactive: !isActiveCode }">
        {{ promocodeText }}
      </div>
      <app-button
        :disabled="!isActiveCode"
        class="promocode__section-button"
        @click="copyPromocode"
      >
        <span>{{ code?.promocode }}</span>
        <copy-clipboard-icon v-if="isActiveCode" class="icon" />
      </app-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
:deep {
  .v-btn {
    padding: 15px 20px !important;
  }

  .app-button.v-btn.v-btn--disabled[disabled] {
    font-weight: 800;
    color: $unactive-grey !important;
    background: $button-background !important;
    box-shadow: none;
  }

  .v-btn__overlay {
    opacity: 0 !important;
  }
}
.promocode {
  display: grid;
  gap: 10px 0;
  height: max-content;
  color: $text-black;
  &__title {
    font-size: 16px;
    font-weight: 800;
    line-height: 19px;
  }
  &__section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &-text {
      max-width: 200px;
      font-size: 12px;
      font-weight: 600;
      line-height: 19.6px;
    }
    &-button {
      min-height: 50px !important;
      font-weight: 700;
      color: $white !important;
      border-radius: 10px;
      box-shadow: 0 4px 20px rgba(255, 80, 0, 0.16);
      .icon {
        margin-left: 10px;
      }
    }

    .unactive {
      max-width: max-content;
      font-size: 16px;
      font-weight: 800;
    }
  }
}
</style>
